// Ordered → Packed → Shipped → Out for delivery → Delivered. A parcel coming
// back (RTO) gets its own three steps instead. Horizontal on wide screens,
// vertical on phones; the current step is marked with aria-current.

const FORWARD = ['Ordered', 'Packed', 'Shipped', 'Out for delivery', 'Delivered']
const RETURN = ['Shipped', 'Returning to seller', 'Returned']

const FORWARD_INDEX = {
  created: 1,
  awb_assigned: 1,
  pickup_scheduled: 1,
  pickup_failed: 1,
  in_transit: 2,
  unknown: 2,
  out_for_delivery: 3,
  delivery_failed: 3,
  delivered: 4,
}

/** `stage` is null before the order has a shipment - then it's placed or being packed. */
export default function TrackingStepper({ stage, orderStatus }) {
  const returning = stage === 'rto' || stage === 'rto_delivered'
  const steps = returning ? RETURN : FORWARD
  const current = returning
    ? stage === 'rto_delivered' ? 2 : 1
    : stage
      ? FORWARD_INDEX[stage] ?? 2
      : String(orderStatus ?? '').toLowerCase() === 'processing' ? 1 : 0
  const failed = stage === 'delivery_failed'
  const done = current === steps.length - 1 && !failed

  return (
    <ol className="flex flex-col sm:flex-row gap-3 sm:gap-0" aria-label="Delivery progress">
      {steps.map((label, i) => {
        const reached = i < current || (i === current && done)
        const isCurrent = i === current
        const tone = isCurrent && failed ? 'bg-red-500 border-red-500 text-white' : reached || isCurrent ? 'bg-secondary border-secondary text-white' : 'bg-white border-border text-primary/30'
        return (
          <li key={label} className="flex sm:flex-col items-center sm:flex-1 gap-3 sm:gap-2 relative" aria-current={isCurrent ? 'step' : undefined}>
            {i > 0 && (
              <span
                className={`hidden sm:block absolute top-4 right-1/2 w-full h-0.5 -z-0 ${i <= current ? 'bg-secondary' : 'bg-border'}`}
                aria-hidden="true"
              ></span>
            )}
            <span className={`relative z-10 w-8 h-8 shrink-0 rounded-full border-2 flex items-center justify-center text-xs font-bold ${tone}`}>
              {reached ? <i className="fa-solid fa-check" aria-hidden="true"></i> : isCurrent && failed ? <i className="fa-solid fa-exclamation" aria-hidden="true"></i> : i + 1}
            </span>
            <span className={`text-xs tracking-wider sm:text-center normal-case ${isCurrent ? 'text-primary font-semibold' : reached ? 'text-primary/70' : 'text-primary/40'}`}>
              {label}
              {isCurrent && failed && <span className="block text-red-600 text-[11px]">Attempt failed</span>}
              <span className="sr-only">{reached ? ' (done)' : isCurrent ? ' (current)' : ' (upcoming)'}</span>
            </span>
          </li>
        )
      })}
    </ol>
  )
}
